export enum CustomErrorLogTooltipActionType {
    Open,
    Close,
}

export type CustomErrorLogTooltipAction =
    | {
          type: CustomErrorLogTooltipActionType.Open;
          payload: {
              anchorElement: HTMLElement;
              message: string;
          };
      }
    | {
          type: CustomErrorLogTooltipActionType.Close;
      };

export function closeCustomErrorLogTooltipAction(): CustomErrorLogTooltipAction {
    return {
        type: CustomErrorLogTooltipActionType.Close,
    };
}

export function openCustomErrorLogTooltipAction(
    anchorElement: HTMLElement,
    message: string
): CustomErrorLogTooltipAction {
    return {
        type: CustomErrorLogTooltipActionType.Open,
        payload: {
            anchorElement: anchorElement,
            message: message,
        },
    };
}
